import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { enUS, zhTW } from "@/locales";

/**
 * 翻譯分成三個種類
 * 1. 主要依 Domain 切分，如:餘額(domains.Wallet.balance)
 * 2. 次要依 Page 切分，如：登入(pages.Login.login)
 * 3. 其他依 System Info、Error Message 切分，如:帳號或密碼錯誤(systems.Error.incorrectUsernameOrPassword)
 */
const resources = {
  "en-US": {
    translation: enUS,
  },
  "zh-TW": {
    translation: zhTW,
  },
};

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en-US",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

export default i18n;

export type I18nT = typeof i18n.t;

export const t: I18nT = i18n.t;

/** 僅供類型使用，無實質翻譯功能 */
export const noopT: I18nT = ((key: string) => key) as any;
